import { Link } from "react-router-dom";
import "./logo.css";

const Logo = () => (
  <Link to="/" className="wordmark">
    e-doc<span className="dot">.</span>
  </Link>
);

export default Logo;
